var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedChevronDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55677 0.630918L6.0001 4.18759L2.44344 0.630918C2.08594 0.273418 1.50844 0.273418 1.15094 0.630918C0.793438 0.988418 0.793438 1.56592 1.15094 1.92342L5.35844 6.13092C5.71594 6.48842 6.29344 6.48842 6.65094 6.13092L10.8584 1.92342C11.2159 1.56592 11.2159 0.988418 10.8584 0.630918C10.5009 0.282585 9.91427 0.273418 9.55677 0.630918Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedChevronDownIcon);
export default __webpack_public_path__ + "static/media/DeprecatedChevronDownIcon.fb689e898b6d9ebcc67c4ea38450360e.svg";
export { ForwardRef as ReactComponent };